<template>
  <draggable :id="`sheet-${sheet._id}`" :group="{name: 'sheets', pull: 'clone', put: false}" tag="div" @dragstart="dragstart"
       class="sheet" :style="{backgroundColor: sheet.color || 'var(--color-checked)', color: invertColor(sheet.color)}">
      <div>{{tablesLen}} 桌</div>
      <div>{{sheet.visitTime}}</div>
    <div :title="(sheet.tables||[]).join(' | ')"><div :class="sheet.level===1?'vip':sheet.level===2?'vvip':sheet.level===3?'supervip':''"></div>{{sheet.orderer}}(
      <span v-if="sheet.reserveNum">{{sheet.reserveNum}}{{sheet.reserveNumChild?'大':'人'}}</span>
      <span v-if="sheet.reserveNumChild">{{sheet.reserveNumChild}}{{sheet.reserveNum?'小':'人'}}</span>
      )</div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  components: { draggable },
  props: ['sheet'],
  computed: {
    tablesLen () {
      return this.sheet.tables?.length
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
